import type { StaticImageData } from 'next/image'

import { cn } from '@/utilities/ui'
import React from 'react'
import RichText from '@/components/RichText'

import type { MediaBlock as MediaBlockProps } from '@/payload-types'

import { Media } from '../../components/Media'
import { PlayableVideoMedia } from '../../components/Media/PlayableVideoMedia'

type Props = MediaBlockProps & {
  breakout?: boolean
  captionClassName?: string
  className?: string
  enableGutter?: boolean
  /** Absolutely fill the parent box (parent must be relative) — used by the
   *  page-level media panel wrapper in RenderBlocks. */
  fill?: boolean
  imgClassName?: string
  staticImage?: StaticImageData
  disableInnerContainer?: boolean
}

export const MediaBlock: React.FC<Props> = (props) => {
  const {
    captionClassName,
    className,
    enableGutter = true,
    fill,
    imgClassName,
    media,
    staticImage,
    disableInnerContainer,
  } = props

  let caption
  if (media && typeof media === 'object') caption = media.caption

  return (
    <div
      className={cn(
        '',
        {
          container: enableGutter,
        },
        className,
      )}
    >
      {media && typeof media === 'object' && media.mimeType?.startsWith('video') && media.url ? (
        /* Click-to-play video panel — Figma `Video` 4093:73284 (accent play icon button) */
        <PlayableVideoMedia url={media.url} />
      ) : (
        (media || staticImage) && (
          <Media
            fill={fill}
            imgClassName={cn(
              fill ? imgClassName : ['border border-border rounded-[0.8rem]', imgClassName],
            )}
            resource={media}
            src={staticImage}
          />
        )
      )}
      {caption && (
        <div
          className={cn(
            'mt-6',
            {
              container: !disableInnerContainer,
            },
            captionClassName,
          )}
        >
          <RichText data={caption} enableGutter={false} />
        </div>
      )}
    </div>
  )
}
